import * as THREE from 'three';
import { Clock } from 'three';
import { EventBusSingleton } from 'light-event-bus'
// import { ChromaticAberrationEffect, EffectComposer, EffectPass, RenderPass, NoiseEffect, GridEffect, BlendFunction } from "postprocessing";
import SceneSubject from './SceneSubject';
import GeneralLights from './GeneralLights';

const TWEEN = require('tween.js');


export default canvas =>
{
    const subscription = EventBusSingleton.subscribe('slide-changed', arg => updateLookAt(arg));
    let lookAtVector = new THREE.Vector3(120, 0, 0);

    function updateLookAt(arg)
    {
        lookAtVector = arg;
    }

    const clock = new Clock();

    const screenDimensions = {
        width: canvas.width,
        height: canvas.height
    };

    const scene = buildScene();
    const renderer = buildRender(screenDimensions);
    const camera = buildCamera(screenDimensions);
    const sceneSubjects = createSceneSubjects(scene);

    // postprocessing
    // const composer = new EffectComposer( renderer );
    // // let dotScreenEffect = new ChromaticAberrationEffect({offset: new THREE.Vector2(0.005, 0.005), blendFunction: BlendFunction.MULTIPLY});
    // // let dotScreenEffect = new DotScreenEffect({ scale: 5 });
    // let gridEffect = new GridEffect({ scale: 10 });
    // let anaglyphEffect = new ChromaticAberrationEffect({offset: new THREE.Vector2(0.005, 0.005), blendFunction: BlendFunction.ALPHA});
    // const effectPass1 = new EffectPass(camera, gridEffect);
    // const effectPass2 = new EffectPass(camera, anaglyphEffect);
    // // effectPass1.renderToScreen = true;
    // effectPass2.renderToScreen = true;
    // composer.addPass(new RenderPass(scene, camera));
    // composer.addPass(effectPass1);
    // composer.addPass(effectPass2);


    function buildScene()
    {
        const scene = new THREE.Scene();
        return scene;
    }

    function buildRender({ width, height })
    {
        const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
        const DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;
        renderer.setPixelRatio(DPR);
        renderer.setSize(width, height);

        renderer.gammaInput = true;
        renderer.gammaOutput = true;

        return renderer;
    }

    function buildCamera({ width, height })
    {
        const aspectRatio = width / height;
        const fieldOfView = 60;
        const nearPlane = 4;
        const farPlane = 100;
        const camera = new THREE.PerspectiveCamera(fieldOfView, aspectRatio, nearPlane, farPlane);
        camera.position.x = 80;
        camera.position.y = 0;
        camera.position.z = 0;
        camera.lookAt(new THREE.Vector3(120, 0, 0));
        return camera;
    }

    function createSceneSubjects(scene)
    {
        const sceneSubjects = [
            new GeneralLights(scene),
            new SceneSubject(scene)
        ];
        return sceneSubjects;
    }

    function update(mouseX, mouseY)
    {
        TWEEN.update();

        const elapsedTime = clock.getElapsedTime();

        if (lookAtVector.z !== 0) {
            camera.position.x = 0 + mouseX;
        }
        else {
            camera.position.z = 0 + mouseX;
        }

        camera.position.y = 0 + mouseY;
        camera.lookAt(lookAtVector);

        for(let i=0; i<sceneSubjects.length; i++)
            sceneSubjects[i].update(elapsedTime);

        renderer.render(scene, camera);
        // composer.render(clock.getDelta());
    }

    function onSlideChange(newPos)
    {
        let from = {
            x: camera.position.x,
            y: camera.position.y,
            z: camera.position.z
        };

        var to = {
            x: newPos.x,
            y: newPos.y,
            z: newPos.z
        };
        var tween = new TWEEN.Tween(from)
            .to(to, 2300)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate(function () {
                camera.position.set(this.x, this.y, this.z);
            })
            .start();
    }

    function onWindowResize()
    {
        const { width, height } = canvas;

        screenDimensions.width = width;
        screenDimensions.height = height;

        camera.aspect = width / height;
        camera.updateProjectionMatrix();

        renderer.setSize(width, height);
    }

    return {
        update,
        onWindowResize,
        onSlideChange
    }
}